module.exports = __webpack_public_path__ + "static/media/chainless.1b56d162.png";